import React, { useState } from "react";
import { connect } from "react-redux";
import QRCode from "qrcode";
import { Main } from "layouts";
import { saveAs } from "file-saver";
import { pdf } from "@react-pdf/renderer";
import { StickerUser } from "sticker_templates";
import { MainList } from "components";
import { getUserRoleName } from "utils/user_role_options";
import { getWorkModeName } from "utils/work_mode_options";
import { getSettlementTypeName } from "utils/settlement_type_options";
import { sort, filters } from "./const/data";

import { ReactComponent as UserIcon } from "icons/user.svg";
import { client_v2 } from "utils/api";
import { setCookie } from "utils/cookies";

const getAuthToken = async (expano_board_user_id) => {
  try {
    const { auth_token } = await client_v2.get(
      `/users/auth_token?expano_board_user_id=${expano_board_user_id}`,
    );
    return auth_token;
  } catch (error) {
    throw error;
  }
};

const Users = ({ current_user, history }) => {
  const is_admin = current_user.role === "admin";

  const [is_loading, setLoading] = useState(false);
  const [is_loading_change_user, setLoadingChangeUser] = useState(false);

  const generateSticker = async ({
    expano_board_user_id,
    first_name,
    last_name,
  }) => {
    try {
      setLoading(true);
      const auth_token = await getAuthToken(expano_board_user_id);

      const code = await QRCode.toDataURL(`auth_token|${auth_token}`);

      const blob = await pdf(
        <StickerUser
          data={{
            first_name,
            last_name,
            code,
          }}
        />,
      ).toBlob();

      saveAs(blob, `${first_name}_${last_name}.pdf`);
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const changeUser = async (expano_board_user_id) => {
    try {
      setLoadingChangeUser(true);
      const auth_token = await getAuthToken(expano_board_user_id);
      setCookie("wms_token", auth_token);
      setCookie("wms_skip_station_scan", 1);
      window.location.reload();
    } catch (error) {
      console.log(error);
    } finally {
      setLoadingChangeUser(false);
    }
  };

  return (
    <Main
      page={{
        name: "Użytkownicy",
        icon: <UserIcon />,
        breadcrumbs: [{ name: "Użytkownicy" }],
      }}
    >
      <MainList
        query_key="users"
        api_path="/users"
        api_context="ui_index"
        sort_column="id"
        sort_direction="desc"
        sort={sort}
        filters={filters}
        renderActions={({ id, expano_board_id, first_name, last_name, role }) =>
          [
            is_admin && {
              type: "preview",
              disabled: is_loading_change_user,
              handleClick: () => changeUser(expano_board_id),
            },
            role !== "admin" && {
              type: "qr_code",
              disabled: is_loading,
              handleClick: () =>
                generateSticker({
                  expano_board_user_id: expano_board_id,
                  first_name,
                  last_name,
                }),
            },
            {
              type: "edit",
              handleClick: () => history.push(`/users/${id}`),
            },
          ].filter(Boolean)
        }
        renderItem={({
          id,
          email,
          first_name,
          last_name,
          role,
          is_pieceworker,
          work_mode,
          can_inventorize_heavy,
        }) => (
          <>
            <td>{id}</td>
            <td>{email}</td>
            <td>{first_name}</td>
            <td>{last_name}</td>
            <td>{getUserRoleName(role)}</td>
            <td>{getSettlementTypeName(is_pieceworker)}</td>
            <td>{getWorkModeName(work_mode)}</td>
            <td>{can_inventorize_heavy ? "Tak" : "Nie"}</td>
          </>
        )}
      />
    </Main>
  );
};

export default connect(({ current_user }) => ({ current_user }))(Users);
